// 系统字段
import { useDispatch, useSelector } from 'dva';
import styles from './index.less?modules';
import { useEffect, useCallback, createContext, useState } from 'react';
import SearchGroup from './components/search_group/SearchGroup';
import TablePage from './components/table_page/TablePage';
import ApprovalList from './components/approval_list/ApprovalList';
import { isEmptyObject } from '@/utils/comUtil.js';
import { history } from 'umi';
import { message } from 'antd';

export const FunctionContext = createContext({
  fetchData: () => {},
});
const Dvm = () => {
  const dispatch = useDispatch();
  const loadingEffect = useSelector((state) => state.loading);
  const loading = loadingEffect.effects['dvm/getDiagramVersionList'];
  const bizData = useSelector((state) => state.dvm.fieldList);
  // const searchValue = useSelector((state) => state.dvm.searchValue);
  const [diagramName, setDiagramName] = useState('');
  const [disabled, setDisabled] = useState(true);
  const [versionList, setVersionList] = useState([]);
  // const [tableDataUse, setTableDataUse] = useState([]);

  // 条件查询列表
  const fetchData = useCallback(
    (searchValue) => {
      dispatch({
        type: 'dvm/getDiagramVersionList',
        payload: {
          values: {
            ...searchValue,
          },
        },
      });
    },
    [dispatch],
  );

  const selectName = (e) => {
    if (e) {
      setDiagramName(e);
      dispatch({
        type: 'dvm/getVersion',
        payload: {
          values: {
            diagramName: e,
          },
        },
        callback: (res) => {
          let result = [];
          if (res.message) {
            message.error(res.message);
          } else {
            res &&
              res.forEach((item) => {
                result.push({ value: item, name: item });
              });
            setVersionList(result);
            setDisabled(false);
          }
        },
      });
    } else {
      setDisabled(true);
    }
  };

  const pushDecisionGraphMap = (e) => {
    history.push({
      pathname: '/bre/dgm/dgm/dgmp',
      query: {
        id: e.diagramId,
        title: e.name,
        version: e.version,
      },
    });
  };

  // 发起请求
  useEffect(() => {
    fetchData({});
  }, [fetchData]);
  return (
    <FunctionContext.Provider value={{ fetchData }}>
      <div className={styles.mm_content}>
        <SearchGroup
          selectName={selectName}
          fetchData={fetchData}
          disabled={disabled}
          versionList={versionList}
        />
        <ApprovalList diagramName={diagramName} />
        <TablePage
          pagination={{
            total: !isEmptyObject(bizData) ? bizData.length : 0,
          }}
          loading={loading}
          tableData={bizData}
          loadingstatus={loading}
          pushDecisionGraphMap={pushDecisionGraphMap}
        />
      </div>
    </FunctionContext.Provider>
  );
};

export default Dvm;
